import { computed } from 'vue';
import type { Ref } from 'vue';

export function useTaskEmailResponseExpose(TaskEmailResponseRef: Ref<any>) {
  return {
    acknowledgeBtnAction: computed(() => TaskEmailResponseRef.value?.acknowledgeBtnAction),
    btnAction: computed(() => TaskEmailResponseRef.value?.btnAction),
    btnClass: computed(() => TaskEmailResponseRef.value?.btnClass),
    btnIcon: computed(() => TaskEmailResponseRef.value?.btnIcon),
    btnText: computed(() => TaskEmailResponseRef.value?.btnText),
    editMode: computed(() => TaskEmailResponseRef.value?.editMode),
    editModeOff: computed(() => TaskEmailResponseRef.value?.editModeOff),
    editModeOn: computed(() => TaskEmailResponseRef.value?.editModeOn),
    isDirty: computed(() => TaskEmailResponseRef.value?.isDirty),
    partner: computed(() => TaskEmailResponseRef.value?.partner),
    secondaryBtnAction: computed(() => TaskEmailResponseRef.value?.secondaryBtnAction),
    secondaryBtnIcon: computed(() => TaskEmailResponseRef.value?.secondaryBtnIcon),
    secondaryBtnText: computed(() => TaskEmailResponseRef.value?.secondaryBtnText),
    showAcknowledgeBtn: computed(() => TaskEmailResponseRef.value?.showAcknowledgeBtn),
    showResponse: computed(() => TaskEmailResponseRef.value?.showResponse),
    toggleEditMode: computed(() => TaskEmailResponseRef.value?.toggleEditMode),
  };
}
